export const config = {
  infuraId: "ca44ce9a485946dc9625c88bd5431eed",
  contractAddress: "0x2Ac9795Ca8fc6d09a5748CB9E8B9D67f4B09df07",
  price: 0.03,
  friendPrice: 0.02,
}
